enum PageTitle {
  TRIALS = 'Processos',
  COMPANIES = 'Empresas',
  CASH_FLOWS = 'Fluxo de Caixa',
  USERS = 'Usuários',
  TASKS = 'Serviços',
}

export default PageTitle;
